import { render } from "./TagsEditor.vue?vue&type=template&id=64252bc0&scoped=true&ts=true"
import script from "./TagsEditor.vue?vue&type=script&lang=ts"
export * from "./TagsEditor.vue?vue&type=script&lang=ts"

import "./TagsEditor.vue?vue&type=style&index=0&id=64252bc0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64252bc0"]])

export default __exports__